import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import fleetcar from "../assets/images/services/fleet-services.png";
import registration from "../assets/images/services/registration.png";
import monitoring from "../assets/images/services/fuel-refill-monitoring.png";
import regulations from "../assets/images/services/compliance-with-laws-regulations.png";
const FleetServices = () => {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={12} md={6} className="pr-0">
              <div className="contact-banner">
                <h4>FLEET SERVICES</h4>
                <p>
                  Hive Employee Transportation And Cab Services ensures that fleet vehicles are
                  up-to-date with minimal maintenance costs. As part of our
                  fleet service, we cater to driver services, vehicle
                  maintenance and other associated statutory compliance. We
                  offer car rental services- SUVs, Sedan, hatchbacks, to
                  corporates. Additionally, we also support chauffeur driven
                  cars for all your business needs. What makes us renowned in
                  the industry is that all our vehicles comply with laws and
                  regulations to cater to corporate services with an excellent
                  track record.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} className="pr-0">
              <img src={fleetcar} className="img-fluid" alt=""></img>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section">
        <Container>
          <Row>
            <Col xs={12} md={12}>
              <div className="main-title text-center">
                <h4>OUR FLEET MANAGEMENT SERVICES INCLUDE </h4>
                <div className="divider-center"></div>
              </div>
            </Col>
          </Row>
          <Row className="mt-60">
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={ registration} className="img-fluid" alt=""></img>
                <h6>UP-TO-DATE REGISTRATION </h6>
                <p>
                Our team ensures that all our vehicles are up-to-date in terms of registrations and renewals so that no fine and penalty occurs.
                </p>
        
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={ monitoring} className="img-fluid" alt=""></img>
                <h6>FUEL REFILL MONITORING </h6>
                <p>
                  Our staff and drivers ensure that all vehicles have sufficient fuel so that they don’t breakdown while in transit.
                </p>
        
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="card-service pt-40">
                <img src={ regulations} className="img-fluid" alt=""></img>
                <h6>COMPLIANCE WITH LAWS AND REGULATIONS </h6>
                <p>
                  We make sure that all our vehicles comply with the motor vehicle act and environmental benefits.
                </p>
        
              </div>
            </Col>
           
          </Row>
         
        </Container>
      </div>
    </div>
  );
};

export default FleetServices;
